<template>
  <div class="s-diseases-container container">
    <topNav></topNav>
    <div class="s-diseases-top">
      <div class="banner w1300 marginAuto"></div>
      <div class="w1300 marginAuto">
        <div class="queryDiv">
          <el-select v-model="sortValue" size="small" style="margin-left:10px" class="search_input1" placeholder="请选择" @change="changeSort">
            <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-show="currentTab ==0" v-model="positionType" size="small" style="margin-left:10px" class="search_input1" placeholder="请选择" @change="changePositionType">
            <el-option v-for="item in typeOptions" :key="item.CODE_VALUE" :label="item.CODE_NAME" :value="item.CODE_NAME"></el-option>
          </el-select>
          <el-select v-show="currentTab ==1" v-model="positionType" size="small" style="margin-left:10px" class="search_input1" placeholder="请选择" @change="changePositionType">
            <el-option v-for="item in typeOptions" :key="item.CODE_VALUE" :label="item.CODE_NAME" :value="item.CODE_VALUE"></el-option>
          </el-select>

          <el-input size="small" class="search_input" v-model="queryKey" placeholder="请输入关键字查询"></el-input>
          <div class="issue" @click="handleSearch">搜索</div>
        </div>
      </div>
      <div class="s-professionalInfos-onsultation-tabs w1300 marginAuto">
        <div @click="handleTabs('0')" :class="[
            currentTab == '0'
              ? 's-professionalInfos-onsultation-tabs-active'
              : '',
          ]">茶树病害</div>
        <div @click="handleTabs('1')" :class="[
            currentTab == '1'
              ? 's-professionalInfos-onsultation-tabs-active'
              : '',
          ]">茶树害虫</div>
      </div>
    </div>

    <div class="section w1300 marginAuto sectionList">
      <div class="section-item" v-for="(item, index) in diseasesDataList" :key="index" @click="goDetail(item.id)" v-show="diseasesDataList.length > 0">
        <div class="section-img">
          <img :src=" diseasesInsectPestsImgURL+(item.pathogenUrl?item.pathogenUrl.split(';')[0]:'')" alt="图片" class="bankLogo" />
        </div>
        <p class="itemData">{{item.diseaseName}}</p>
        <!-- <img :src="imgUrlIn" alt="这是银行logo图片" class="bankLogo" /> -->
      </div>
    </div>

    <div class="emptyDiv" v-show="diseasesDataList.length == 0">
      <el-empty description="暂无数据"></el-empty>
    </div>

    <div class="s-transaction-pagination">
      <el-pagination class="tab_pagination" background :pageSize="pageSize" layout="prev, pager, next" @current-change="currentChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import { pageList, diseaseAndPestCode } from "../utils/api/diseasesInsectPests";
export default {
  name: "",
  components: { topNav },
  data() {
    return {
      pestDataList: [],
      diseaseDataList: [],
      typeOptions: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sortValue: "asc",
      queryKey: "",
      positionType: "",
      sortOptions: [
        { label: "正序", value: "asc" },
        { label: "倒序", value: "desc" },
      ],
      currentTab: "0",
      diseasesDataList: [],
    };
  },
  mounted() {
    if (this.$route.query.dataType) {
      this.currentTab = this.$route.query.dataType;
    }

    this.diseaseAndPestCode(this.currentTab);
  },
  methods: {
    handleTabs(val) {
      this.currentTab = val;
      this.$route.query.positionType = "";
      this.diseaseAndPestCode(this.currentTab);
    },
    // 详情
    goDetail(id) {
      this.$router.push({
        path: "diseasesInsectPestsDetail",
        query: { id, type: this.currentTab, positionType: this.positionType },
      });
    },
    async pageList() {
      let obj = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        positionType: this.positionType,
        sort: this.sortValue,
        type: this.currentTab,
        title: this.queryKey,
      };
      let res = await pageList(obj);
      if (res.data.code == 0) {
        if (this.currentTab == 0) {
          this.diseasesDataList = res.data.data.records;
        } else {
          if (res.data.data.records.length > 0) {
            this.diseasesDataList = res.data.data.records.map((item) => {
              item.pathogenUrl = item.pestUrl;
              return {
                pathogenUrl: item.pestUrl,
                diseaseName: item.pestName,
                id: item.id,
              };
            });
          } else {
            this.diseasesDataList = [];
          }
        }
        this.total = res.data.data.total;
      }
    },
    // 切换顺序
    changeSort(val) {
      this.sortValue = val;
      this.currentPage = 1;
      this.pageList();
    },
    // 病虫害类型切换
    changePositionType() {},
    // 获取病虫害种类
    async diseaseAndPestCode(currentTab) {
      let res = await diseaseAndPestCode({ type: currentTab });
      if (res.data.code == 0 || res.data.code == 200) {
        this.typeOptions = res.data.data;
        if (this.$route.query.positionType) {
          this.positionType = this.$route.query.positionType;
        } else {
          if (this.currentTab == 0) {
            this.positionType = res.data.data[0].CODE_NAME;
          } else {
            this.positionType = res.data.data[0].CODE_VALUE;
          }
        }
        this.pageList();
      }
    },
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.pageList();
    },
    // 分页
    currentChange(val) {
      this.currentPage = val;
      this.pageList();
    },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/diseasesInsectPests.scss";
</style>